(function() {
  function init(cfg) {
    var sectionId  = cfg.sectionId;
    var taxaJuros  = cfg.taxaJuros  || 0.0249;
    var semJurosTe = cfg.semJurosTe || 3;

    function calcularParcela(total, n) {
      if (n <= semJurosTe) {
        return { valor: total / n, total: total, juros: false };
      }
      var i = taxaJuros;
      var pmt = total * i / (1 - Math.pow(1 + i, -n));
      return { valor: pmt, total: pmt * n, juros: true };
    }

    function formatarMoeda(valor) {
      return 'R$ ' + valor.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    }

    function atualizarParcelamento(preco) {
      if (!preco || preco <= 0) return;
      var parcela3 = calcularParcela(preco, 3);
      var resumoEl = document.getElementById('vd-parcela-resumo-' + sectionId);
      if (resumoEl) {
        resumoEl.innerHTML =
          'ou <strong id="vd-parcela-valor-' + sectionId + '">3x sem juros de ' +
          formatarMoeda(parcela3.valor) + '</strong>' +
          '&nbsp;<button class="vd-parcelas__ver-todas" id="vd-ver-parcelas-' + sectionId +
          '" type="button">Ver todas as parcelas</button>';

        var btnVer  = document.getElementById('vd-ver-parcelas-'   + sectionId);
        var overlay = document.getElementById('vd-modal-overlay-'  + sectionId);
        if (btnVer && overlay) {
          btnVer.addEventListener('click', function() {
            overlay.classList.add('open');
            document.body.style.overflow = 'hidden';
          });
        }
      }

      var modalBody = document.getElementById('vd-modal-body-' + sectionId);
      if (!modalBody) return;
      var html = '';
      for (var n = 1; n <= 12; n++) {
        var p = calcularParcela(preco, n);
        var badgeHtml = !p.juros ? '<span class="vd-parcela-badge">Sem juros</span>' : '';
        var rowClass  = !p.juros ? 'vd-parcela-row sem-juros' : 'vd-parcela-row';
        html += '<div class="' + rowClass + '">';
        html += '<span class="vd-parcela-numero">' + n + 'x' + badgeHtml + '</span>';
        html += '<span class="vd-parcela-valor">'  + formatarMoeda(p.valor) + '</span>';
        html += '<span class="vd-parcela-total">Total ' + formatarMoeda(p.total) + '</span>';
        html += '</div>';
      }
      modalBody.innerHTML = html;
    }

    /* Busca o preço scoped ao section — evita pegar preço errado em páginas com múltiplos blocks */
    function obterPrecoAtual() {
      var container = document.getElementById('price-' + sectionId);
      if (!container) container = document;

      /* 1. Preço em promoção */
      var el = container.querySelector('.price-item--sale.main-price');
      /* 2. Preço regular */
      if (!el) el = container.querySelector('.price-item--regular.main-price');
      /* 3. Fallback amplo — qualquer price-item visível */
      if (!el) el = container.querySelector('.price-item--sale, .price-item--regular');
      if (!el) return null;

      var texto = el.textContent.trim().replace(/[^\d,]/g, '').replace(',', '.');
      var valor = parseFloat(texto);
      return isNaN(valor) || valor <= 0 ? null : valor;
    }

    function run() {
      var overlay   = document.getElementById('vd-modal-overlay-' + sectionId);
      var btnFechar = document.getElementById('vd-modal-fechar-'  + sectionId);

      if (btnFechar && overlay) {
        btnFechar.addEventListener('click', function() {
          overlay.classList.remove('open');
          document.body.style.overflow = '';
        });
      }
      if (overlay) {
        overlay.addEventListener('click', function(e) {
          if (e.target === overlay) {
            overlay.classList.remove('open');
            document.body.style.overflow = '';
          }
        });
        document.addEventListener('keydown', function(e) {
          if (e.key === 'Escape') {
            overlay.classList.remove('open');
            document.body.style.overflow = '';
          }
        });
      }

      /* Inicializa com preço atual */
      var preco = obterPrecoAtual();
      if (preco) atualizarParcelamento(preco);

      /* Atualiza ao trocar variante — evento nativo do tema */
      document.addEventListener('variant:change', function(e) {
        if (e.detail && e.detail.variant && e.detail.variant.price) {
          atualizarParcelamento(e.detail.variant.price / 100);
        }
      });

      /* MutationObserver como fallback para temas que não disparam variant:change */
      var priceContainer = document.getElementById('price-' + sectionId)
                        || document.querySelector('.product-page-price');
      if (priceContainer && window.MutationObserver) {
        var lastPrice = preco;
        var observer = new MutationObserver(function() {
          var p = obterPrecoAtual();
          if (p && p !== lastPrice) {
            lastPrice = p;
            atualizarParcelamento(p);
          }
        });
        observer.observe(priceContainer, { childList: true, subtree: true, characterData: true });
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', run);
    } else {
      run();
    }
    document.addEventListener('shopify:section:load', run);
  }

  /* Registra e processa fila de chamadas pendentes (resolve race condition com defer) */
  window.VittaraParcelamento = { init: init };
  var queue = window._VPQueue || [];
  for (var i = 0; i < queue.length; i++) { init(queue[i]); }
  /* Futuras chamadas executam diretamente */
  window._VPQueue = { push: function(cfg) { init(cfg); } };
})();
